
let UploadFileTx = function(optioins,callback){
    this.options = {
      signatureUrl: '',
    }
    this.options = Object.assign(this.options, optioins)
    //console.log('options:', JSON.stringify(this.options))
    this.queue = [];
    this.files = [];
    this.busy = false;
    this.callback = function(){}
    if (callback) {
        this.callback = callback;
    }
    this.upFile = function(file){
        if(file){
            if(Object.prototype.toString.call(file) === '[object Array]'){
                this.queue = this.queue.concat(file);
            }
            else {
                this.queue.push(file);
            }
            this.doUpFile();
        }
    }
    this.doUpFile = function(){
        if(this.busy){
            return
        }
        let queue = this.queue;
        if(queue.length){
            let file = queue.shift();
            let fileObj = file.file;
            let temp = {}
            Object.keys(file).forEach(key=>{
                if(key!='file'){
                    temp[key] = file[key];
                }
            })
            file = temp;
            requestObj.upFile({
                signatureUrl: this.options.signatureUrl,
                data: fileObj,
                progress: res => {
                    file.state = 'progress';
                    file.progress = res;
                    this.callback(file);
                },
                success: res => {
                    file.state = 'success';
                    /*file.fileUrl = res.data.attachmentName;
                    file.fileId = res.data.attachmentId*/
                    file.fileUrl = res.fileUrl;
                    file.fileId = res.fileId
                    this.callback(file);
                },
                fail: () => {
                    file.state = 'fail';
                    file.fileUrl = '';
                    file.fail = true;
                    this.busy = false;
                    this.callback(file);
                },
                complete: ()=>{
                    this.busy = false;
                    this.doUpFile();
                }
            })
        }
    }
}

/**
 * 计算签名
 **/
function getSignature(){
  return new Promise((resovle, reject) => {
    $.ajax({
      //url: 'https://demo.vod2.myqcloud.com/ugc-upload/',
      url: SIGNATURE_URL,
      data: JSON.stringify({
        "Action":"GetUgcUploadSign"
      }),
      type: 'POST',
      //dataType: 'json',
      success: function(res){
        resovle(res);
        /*if(res.data && res.data.sign) {
          //callback(res.data.sign);
          //return res.data.sign
          resovle(res.data.sign);
        } else {
          reject('获取签名失败')
          //return '获取签名失败';
        }*/
      }
    });
  })

};
let requestObj = {
  upFile: function (options){
    window.SIGNATURE_URL = options.signatureUrl;
    if(!window.tcVod){
      window.tcVod = new TcVod.default({
        getSignature: getSignature // 前文中所述的获取上传签名的函数
      })
    }

    const uploader = tcVod.upload({
      mediaFile: options.data, // 媒体文件（视频或音频或图片），类型为 File
    })
    var uploaderInfo = {}
    uploader.on('media_upload', function(info) {
      uploaderInfo.isVideoUploadSuccess = true;
      //console.log('media_upload', info)
    })
    // 媒体文件上传进度
    uploader.on('media_progress', function(info) {
      //console.log('media_progress', info)
      uploaderInfo.progress = info.percent;
      let percent = parseInt(info.percent * 100) + '%'
      options.progress(percent)
    })
    // 封面上传完成时
    uploader.on('cover_upload', function(info) {
      //console.log('cover_upload', info)
      uploaderInfo.isCoverUploadSuccess = true;
    })
    // 封面上传进度
    uploader.on('cover_progress', function(info) {
      //console.log('cover_progress', info)
    })
    // 成功
    uploader.done().then(function (doneResult) {
      // console.log('------fddd',doneResult)
      options.success({
        fileUrl:  doneResult.video.url,
        fileId: doneResult.fileId
      })
      //console.log(doneResult)
    })

  }
}
export default UploadFileTx;
